import { useEffect as c } from "react";
const i = _ref => {
  let {
    closeCallback: e,
    open: o,
    modalRef: n,
    preventCloseOnOutsideClick: t
  } = _ref;
  c(() => {
    if (t || !o) return;
    const r = s => {
      o && n.current && !n.current.contains(s.target) && e && e();
    };
    return window.addEventListener("mousedown", r), () => {
      window.removeEventListener("mousedown", r);
    };
  }, [e, n, t, o]);
};
export { i as useClickOutside };